import React, { Component } from 'react';
import { connect } from 'react-redux';
import SliderForm from './SliderForm';
import privateView from '../../components/hocs/privateView';
import Analytics from "../../services/Analytics";

class SliderDetail extends Component{
	componentDidMount(){
    const { email } = this.props.injectedProps;
    Analytics.recordPageView('slider_detail', email, {
      url: window.location.href,
      location: this.props.location,
      match: this.props.match
    });
  }
  render(){
    return (
      <div>
        <SliderForm
          edit
          title="Slider Detail"
          {...this.props}
        />
      </div>
    )
  }
}

const mapStateToProps = ({auth: { isFetch, roles, isLogged, index, email } })=>({
  guardData: { isFetch, roles, isLogged, index, email }
})

const enhance = connect(mapStateToProps);
export default enhance(privateView(SliderDetail))